export const createGameEndSlice = (props)=>(set, get)=>({
            gameEnd: {
                isVisible: false,
                setIsVisible: (isVisible)=>set({
                        gameEnd: {
                            ...get().gameEnd,
                            isVisible: isVisible
                        }
                    }),
                isAfterLiveGame: false,
                setIsAfterLiveGame: (isAfterLiveGame)=>set({
                        gameEnd: {
                            ...get().gameEnd,
                            isAfterLiveGame: isAfterLiveGame
                        }
                    }),
                setEndControls: (endControls)=>set({
                        gameEnd: {
                            ...get().gameEnd,
                            endControls: endControls
                        }
                    }),
                setProviderProps: (providerProps)=>set({
                        gameEnd: {
                            ...get().gameEnd,
                            providerProps: providerProps
                        }
                    }),
                numberOfPlayersJoinedRematch: 0,
                setNumberOfPlayersJoinedRematch: (numberOfPlayersJoinedRematch)=>set({
                        gameEnd: {
                            ...get().gameEnd,
                            numberOfPlayersJoinedRematch: numberOfPlayersJoinedRematch
                        }
                    }),
                isSharingEnabled: props.isSharingEnabled,
                gameEndShareIcon: props.gameEndShareIcon,
                gameEndedCallback: props.gameEndedCallback
            }
        });
